import { IconeCheck } from '@/components/atoms/Icones/IconeCheck';
import { construirSombra } from '@/styles/theme';
import styled, { css, useTheme } from 'styled-components';

interface CheckboxProps {
  $size: 1 | 2 | 3;
  $variant: 'classic' | 'surface' | 'soft';
  $highContrast: boolean;
  $status: 'unchecked' | 'checked' | 'indeterminate';
}

const Container = styled.div<CheckboxProps>`
  display: flex;
  align-items: center;

  ${({ theme, $size }) => {
    return css`
      height: ${theme.typography.font.size[$size + 4]}px;
      width: ${theme.typography.font.size[$size + 4]}px;
    `;
  }}

  border-radius: ${({ theme }) => theme.radius[2]}px;

  ${({ theme, $variant, $status, $highContrast }) => {
    function definirCorBorda() {
      switch ($status) {
        case 'checked':
          return theme.colors.accent.accent[9];
        case 'indeterminate':
          return theme.colors.accent.accent_alpha[8];
        default:
          return theme.colors.neutral.neutral_alpha[7];
      }
    }

    function definirCorDeFundo() {
      switch ($status) {
        case 'checked':
          return theme.colors.accent.accent[$highContrast ? 12 : 10];
        case 'indeterminate':
          return $highContrast
            ? theme.colors.accent.accent_alpha[3]
            : theme.tokens.colors.accent_surface[8];
        default:
          return 'transparent';
      }
    }

    if ($variant === 'classic') {
      return css`
        background-color: ${definirCorDeFundo()};
        border: 1px solid ${definirCorBorda()};
        box-shadow: ${construirSombra('shadow_1')};
      `;
    }
  }};
`;

export default function Checkbox(props: CheckboxProps) {
  const { $status, $size, $highContrast } = props;
  const theme = useTheme();

  const tamanhoIcone = theme.typography.font.size[$size + 4];

  return (
    <Container {...props}>
      {$status === 'checked' ? (
        <IconeCheck
          size={tamanhoIcone}
          color={
            $highContrast
              ? theme.colors.neutral.neutral[1]
              : theme.tokens.colors.accent_contrast
          }
        />
      ) : (
        <div
          style={{
            height: tamanhoIcone,
            width: tamanhoIcone,
          }}
        />
      )}
    </Container>
  );
}
